<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Kategorimärken
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Märken identifierar receptkategori. Färgen hämtas från
      <span
        class="font-mono text-[13px] bg-[#f2f4f6] px-1.5 py-0.5 rounded-[5px]"
        >category.color</span
      >
      i databasen. Om ingen databas-färg finns används en hash av kategorinamnet
      mot en fast palett med 8 färger.
    </p>

    <PreviewBox label="Text-varianter (receptkort)">
      <span
        v-for="b in textBadges"
        :key="b.label"
        class="font-[Poppins] font-bold text-[10px] tracking-[1px] uppercase"
        :style="{ color: b.color }"
        >{{ b.label }}</span
      >
    </PreviewBox>

    <PreviewBox label="Fylld variant (hero / redaktionell)">
      <span
        v-for="b in filledBadges"
        :key="b.label"
        class="font-[Poppins] font-bold text-[10px] tracking-[1px] uppercase px-3 py-1 rounded-full"
        :style="{ color: b.fg, backgroundColor: b.bg }"
        >{{ b.label }}</span
      >
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Kategorimärke med dynamisk bakgrundsfärg -->
<span
  class="px-2.5 py-1 rounded-full font-[Poppins] font-bold text-[11px] tracking-[0.4px] uppercase"
  :style="{ backgroundColor: categoryColor, color: '#fff' }"
>
  {{ categoryName }}
</span>

<!-- Fallback om ingen färg finns -->
<span class="px-2.5 py-1 rounded-full bg-teal-500 text-white font-[Poppins] font-bold text-[11px] uppercase">
  {{ categoryName }}
</span>`;
const cssCode = `/* Märke-base */
border-radius: 9999px;   /* rounded-full */
padding: 4px 10px;       /* py-1 px-2.5 */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 11px;
letter-spacing: 0.4px;
text-transform: uppercase;

/* Färgpalett (category.color) */
/* #14b8a6  #f59e0b  #8b5cf6  #ec4899 */
/* #3b82f6  #ef4444  #10b981  #f97316 */`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
const textBadges = [
  { label: "PASTA", color: "#14b8a6" },
  { label: "BAKVERK", color: "#f59e0b" },
  { label: "VEGETARISKT", color: "#10b981" },
  { label: "SALLAD", color: "#3b82f6" },
  { label: "FRUKOST", color: "#8b5cf6" },
  { label: "DRINK", color: "#ec4899" },
  { label: "MIDDAG", color: "#f97316" },
  { label: "SOPPA", color: "#ef4444" },
];
const filledBadges = [
  { label: "MÄSTARKLASS", bg: "#14b8a6", fg: "white" },
  { label: "BASICS", bg: "#f59e0b", fg: "#684000" },
  { label: "VERKTYG", bg: "#8b5cf6", fg: "white" },
  { label: "UTVALT RECEPT", bg: "#ec4899", fg: "white" },
  { label: "UTMANING", bg: "#ef4444", fg: "white" },
];
</script>
